function initFeaturedProductsRowSplides() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-featured-products-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var count = el.querySelectorAll('.featured-products-row__item').length;
    var perPageDesktop = Math.min(count, 5);

    /* Mobile shows one product plus a peek of the next one. perPage must stay an
       integer: Splide uses it for the index math (getEnd/toPage/toIndex), and a
       fractional value makes getEnd() fractional too, which resolves Next to a
       non-existent slide index and snaps the track back to the start.
       The peek is produced with fixedWidth instead — the value below is the exact
       width Splide itself generated for perPage: 1.335, so the layout is unchanged. */
    var mobileGap = '10px';
    var mobilePerView = 1.335;
    var mobileSlideWidth = 'calc((100% + ' + mobileGap + ')/' + mobilePerView + ' - ' + mobileGap + ')';

    var slider = new Splide(el, {
      type: 'slide',
      perPage: perPageDesktop,
      perMove: 1,
      gap: '16px',
      pagination: false,
      arrows: false,
      drag: true,
      breakpoints: {
        991: {
          perPage: 1,
          perMove: 1,
          gap: mobileGap,
          fixedWidth: mobileSlideWidth,
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var prevBtn = el.querySelector('.featured-products-row__arrows .featured-products-row__arrow-btn--prev');
    var nextBtn = el.querySelector('.featured-products-row__arrows .featured-products-row__arrow-btn--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.go('<');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.go('>');
      });
    }

    var bar = el.querySelector('.js-featured-products-progress-bar');

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;

      /* Clamp so the bar and the arrows can never disagree with the track,
         e.g. right after a breakpoint switch changes perPage. */
      var index = Math.min(Math.max(slider.index, 0), end);

      if (bar) {
        var rate = Math.min((index + 1) / (end + 1), 1);
        bar.style.width = String(100 * rate) + '%';
      }
      if (prevBtn) {
        prevBtn.disabled = index <= 0;
      }
      if (nextBtn) {
        nextBtn.disabled = index >= end;
      }
    }

    /* move/moved cover arrows and swipes, updated/refresh/resized cover the
       991px breakpoint switch, orientation changes and the iOS URL-bar resize. */
    slider.on('mounted move moved updated refresh resized scrolled', syncControls);

    slider.mount();
  });
}

document.addEventListener('DOMContentLoaded', initFeaturedProductsRowSplides);
window.addEventListener('load', initFeaturedProductsRowSplides);

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.js-featured-products-splide') || node.querySelector('.js-featured-products-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initFeaturedProductsRowSplides();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
